import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import PDP from "ab-pdp";
import SEO from "ab-seo";
import ConfiguradorEstuches from "ab-configurador-estuches";

import DynamicContent from "../../components/DynamicContent";
import { getPage, getProduct, getCategory } from "ab-api-queries";
import { redirect } from "next/dist/server/api-utils";

const Home = ({
  content = [],
  category,
  product,
  moduloCross,
  personalizacion,
  etiquetaSKU,
  seo
}) => {
  const { i18n } = useTranslation("common");
  if (product?.configuradorEstuches?.numeroBotellas) {
    return (
      <>
        <SEO
          seo={{
            title: `${product?.name} | ${product?.productCategories?.nodes?.[0].name} | Abadía Retuerta`,
            description: `Compra en nuestra tienda online un/una ${product?.name}. Los mejores productos exclusivos para tu disfrute. Envío Gratis a partir de 100$. `,
            noindex: seo?.noindex
          }}
        />

        <ConfiguradorEstuches
          {...product}
          i18n={i18n}
          personalizacion={personalizacion}
          etiquetaSKU={etiquetaSKU}
        />
      </>
    );
  } else if (product?.name) {
    return (
      <>
        <SEO
          seo={{
            title: `${product?.name} | ${product?.productCategories?.nodes?.[0].name} | Abadía Retuerta`,
            description: `Compra en nuestra tienda online un/una ${product?.name}. Los mejores productos exclusivos para tu disfrute. Envío Gratis a partir de 100$. `,
            noindex: seo?.noindex
          }}
        />
        <PDP
          {...product}
          i18n={i18n}
          personalizacion={personalizacion}
          etiquetaSKU={etiquetaSKU}
        />
      </>
    );
  } else if (content.length > 0) {
    return (
      <>
        {content?.map((itm, index) => (
          <DynamicContent
            {...itm}
            category={category}
            rtl={index % 2 !== 1}
            moduloCross={moduloCross}
            key={`${itm.fieldGroupName}-${index}`}
            i18n={i18n}
          />
        ))}
      </>
    );
  }
};

export async function getServerSideProps({ locale, params }) {
  let slug = params.slug;
  // The following is becouse theree are some bad QR already printed
  const baseSlug = slug.endsWith('-2') ? slug.slice(0, -2) : slug;
  if (slug.endsWith('-2')) {
    return {
      redirect: {
        destination: `/en/shop/${baseSlug}`,
        permanent: false
      }
    }
  }
  if (slug === 'ledomaine-blanco-de-guarda') {
    return {
      redirect: {
        destination: `/en/shop/blanco-ledomaine`,
        permanent: false
      }
    }
  }
  ///
  const data = await getPage(`tienda/${slug}`);
  const categoryData = await getCategory(slug);
  const productData = await getProduct(slug);
  const personalizacionData = await getProduct("servicio-personalizacion"); //sku 00605
  const etiquetaData = await getProduct(
    process.env.STAGE == "dev"
      ? "personalizacion-botella"
      : "tirilla-extra-personalizada"
  ); //sku 00609


  // const locale = getLocaleFromContext(context);
  // const redirectURL = getLinkFromTranslation(data?.nodeByUri?.translations, locale);

  // if (locale != 'es' && redirectURL) {
  //   return {
  //     redirect: {
  //       permanent: false,
  //       destination: redirectURL
  //     }
  //   };
  // }

  const translations = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      seo: productData?.product?.seo || data?.nodeByUri?.seo || {},
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      category: categoryData?.productCategory || {},
      product: productData?.product || {},
      moduloCross: data?.modulosCross,
      footer: data?.headerFooter?.footer || {},
      menu: data?.headerFooter?.menu || {},
      translations: data?.nodeByUri?.translations || null,
      language: data?.nodeByUri?.language || { code: "ES" },
      personalizacion: personalizacionData?.errors
        ? {}
        : personalizacionData?.product,
      etiquetaSKU: etiquetaData?.errors ? {} : etiquetaData?.product,
      ...translations,
    }, // will be passed to the page component as props
    notFound:
      (!data?.nodeByUri?.contenidoFlexible?.modulos.length > 0 &&
        !productData?.product) ||
      locale !== "es",
  };
}

export default Home;
